import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'organizedUnit', method: 'GET', body: null, token: token })
}
